




























import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

//ポップアップ上部にクローズボタンを配置する
//編集モードの場合、初期状態は読取～エディタ下部の編集ボタンで編集を開始
//新規モードの場合、エディタ下部のキャンセルボタンは配置しない。

@Component
export default class PopupEditor extends Vue {
  @Prop({ default: false }) public value : boolean;
  @Prop({ default: 1080 }) public width : number;
  @Prop({ default: 600 }) public height : number;
  @Prop({default:''}) public title : string;
  @Prop({ default: 'editor' }) public mode : string; //editor/list
  @Prop({ default: false}) public isInsertMode : boolean;

  public svg: string = null;
  public isLoading = true;
  public edittingItem:any = null;
  public offset = 0;

  @Watch('value')
  public onValueChanged(){
    if (this.value) {
      this.isLoading = true;

      var findPopup =(el:HTMLElement) : number =>{
          if (el == document.body) return 0;
          else return findPopup(el.parentElement)  +  (el.className.includes('cx_popup_editor_content') ? 1 : 0);
      };
      this.offset = findPopup(this.$el.parentElement) * 15;
    }
  }
  public onClose(){
    //closingイベントを送出(バリデーション用)

    var arg = {canceled:false, target:this.edittingItem};
    this.$emit('closing',arg);
    if (arg.canceled) return;

    //v-modelを更新する
    this.$emit('input',false);                
  }

}
